import axios from "axios";
import React from "react";
import { useState } from "react";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { BASE_URL } from "../../utils/BaseURL";
import AddressModal from "./UserComponents/AddressModal";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditAddressModal from "./UserComponents/EditAddressModal";

const Addresses = () => {
  const { user } = JSON.parse(localStorage.getItem("user")) || {};
  const [userdata, setuserdata] = useState([]);
  const [flag, setFlag] = useState(false);
  const navigate = useNavigate();
  const [pinshow, setPinshow] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleMouseEnter = (e) => {
    setPinshow(true);
  };

  const handleMouseLeave = () => {
    setPinshow(false);
  };

  const handleDeleteAddress = (id) => {
    axios.delete(`${BASE_URL}/address/${id}`).then((res) => {
      console.log(res);
      if (res?.data?.success) {
        setFlag(!flag);
        enqueueSnackbar("Address Deleted Successfully", { variant: "warning" });
      }
    });
  };

  useEffect(() => {
    axios.get(`${BASE_URL}/address/${user._id}`).then((res) => {
      setuserdata(res.data.data);
      console.log(res.data);
    });
  }, [flag]);

  return (
    <div className=" w-full px-5  py-2">
      <div className=" text-center text-xl font-bold ">Manage Addresses</div>
      <div>
        <div className=" w-full h-10  cursor-pointer  px-5 text-blue-500 font-bold flex  items-center gap-2 ">
          <AddressModal flag={flag} setFlag={setFlag} />
        </div>

        {userdata?.map((data) => (
          <div
            key={data.id}
            className="flex flex-col gap-2 border-2 mt-2  px-2 py-2"
            style={{ borderRadius: "10px" }}
          >
            <div className="flex w-full justify-between relative">
              <div className="text-xs bg-blue-200 px-2 py-1 rounded-sm text-black-400 font-bold">
                {data?.addressType}
              </div>
            </div>

            <Box display={"flex"} flexDirection={"column"}>
              <div>
                <div className="flex gap-3">
                  <div className="font-bold">{data?.name}</div>{" "}
                  <div className="font-bold">{data?.mobile}</div>{" "}
                </div>
                <div>
                  {data?.address}, {data?.city} , {data?.state} <span>-</span>{" "}
                  <span className="font-bold">{data?.pincode}</span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                <Box mb={"5px"}>
                  <EditAddressModal
                    flag={flag}
                    setFlag={setFlag}
                    id={data?._id}
                  />
                </Box>
                <Box>
                  <Button
                    size="small"
                    variant="contained"
                    color="error"
                    onClick={() => handleDeleteAddress(data?._id)}
                  >
                    Delete
                  </Button>
                </Box>
              </div>
            </Box>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Addresses;
